import React from 'react';
import { IconBase } from '../Base';
export const IconCheck = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M18 5H2V15H18V5Z", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeMiterlimit: "10" }),
        React.createElement("path", { d: "M8.75 12L4.75 12", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M15.5 9H13", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeMiterlimit: "10" }),
        React.createElement("path", { d: "M11 9H4", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeMiterlimit: "10" })));
};
//# sourceMappingURL=Check.js.map